import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { HttpModule } from '@angular/http';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { SurfschuleComponent } from './surfschule/surfschule.component';
import { PreiseComponent } from './preise/preise.component';
import { HollandComponent } from './holland/holland.component';
import { AnfahrtComponent } from './anfahrt/anfahrt.component';
import { KontaktComponent } from './kontakt/kontakt.component';
import { ImpressumComponent } from './impressum/impressum.component';
import { MenuComponent } from './menu/menu.component';
import { SliderComponent } from './slider/slider.component';
import { FeedBlockComponent } from './feed-block/feed-block.component';
import { FooterComponent } from './footer/footer.component';
import { CopyrightComponent } from './copyright/copyright.component';

const routes: Routes = [
  {path: '', pathMatch: 'full', redirectTo: 'home'},
  {path: 'home', component: HomeComponent},
  {path: 'surfschule', component: SurfschuleComponent},
  {path: 'preise', component: PreiseComponent},
  {path: 'holland', component: HollandComponent},
  {path: 'anfahrt', component: AnfahrtComponent},
  {path: 'kontakt', component: KontaktComponent},
  {path: 'impressum', component: ImpressumComponent}
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    SurfschuleComponent,
    PreiseComponent,
    HollandComponent,
    AnfahrtComponent,
    KontaktComponent,
    ImpressumComponent,
    MenuComponent,
    SliderComponent,
    FeedBlockComponent,
    FooterComponent,
    CopyrightComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes),
    BrowserAnimationsModule,
    HttpModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/AnnaNorbisrath/WebstormProjects/me.rainer.surfschule-wiesensee/src/app/app.module.ts